import React, { Fragment, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Loader from '../Layout/Loader';
import LayoutRoutes from './LayoutRoutes';
import { authRoutes } from './AuthRoutes';
import PrivateRoute from './PrivateRoute';
import LoginOne from '../Component/Pages/Auth/LoginOne';
import PrivacyPolicy from '../Component/Pages/Auth/PrivacyPolicy';

const Routers = () => {
  const token = localStorage.getItem("TOKEN");

  return (
    <Fragment>
        <BrowserRouter basename={'/'}>
          <>
            <Suspense fallback={<Loader />}>
              <Routes>
                <Route path={'/'} element={<PrivateRoute />}>
                  {token ?
                    <>
                      <Route exact
                        path={`${process.env.PUBLIC_URL}`}
                        element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />}
                      />
                      <Route exact
                        path={`/`}
                        element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />}
                      />
                    </> : ''}
                  <Route path={`/*`} element={<LayoutRoutes />} />
                </Route>
                <Route exact path={`${process.env.PUBLIC_URL}/login`} element={<LoginOne />} />
                <Route exact path={`${process.env.PUBLIC_URL}/privacy-policy`} element={<PrivacyPolicy />} />
                {authRoutes.map(({ path, Component }, i) => (
                  <Route path={path} element={Component} key={i} />
                ))}
              </Routes>
            </Suspense>
          </>
        </BrowserRouter>
    </Fragment >
  );
};
export default Routers;